import { render, staticRenderFns } from "./nfr-service-history.vue?vue&type=template&id=62e2d16f&"
import script from "./nfr-service-history.vue?vue&type=script&lang=tsx&"
export * from "./nfr-service-history.vue?vue&type=script&lang=tsx&"
import style0 from "./nfr-service-history.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports